module.exports = __webpack_public_path__ + "static/img/instagram-svgrepo-com.982eee50.svg";